import React from 'react'

export default function LegalLinks({ termsUrl, privacyUrl, addendumUrl }) {

  return (
    <div className="legal">
      { Cas.translations.legal_notice }
      <a href={ termsUrl } rel="nofollow noindex noreferrer" target="_blank">
        { Cas.translations.terms }
      </a>
      <a href={ privacyUrl } rel="nofollow noindex noreferrer" target="_blank">
        { Cas.translations.privacy }
      </a>
      <a href={ addendumUrl } rel="nofollow noindex noreferrer" target="_blank">
        { Cas.translations.addendum }
      </a>
    </div>
  )
}
